<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Edit Referral Code</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>{{ lps() }}</b>
      /
      <router-link to="/lps/affiliate">Affiliates</router-link>
      /
      <router-link :to="goBack()">
        Affiliate Details
      </router-link>
      /
      <b>Edit Referral Code</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Enter Referral Code's Details</h4>
            <br />
            <div class="row">
              <div class="col-12">
                <label>Referral Code Name</label>
                <input type="text" class="form-control" style="margin-bottom: 10px;" v-model="referralCodeName" />
                <label>Referral Code</label>
                <div class="row">
                  <div class="col-6">
                    <input type="text" class="form-control" style="margin-bottom: 10px;" v-model="referralCode"
                      disabled />
                  </div>
                </div>
                <label>Referral Code Type</label>
                <div class="row">
                  <label class="radio ml-3">
                    <input type="radio" name="codeType" v-model="referralCodeType" v-bind:value="c">
                    <span>Media</span>
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio ml-3">
                    <input type="radio" name="codeType" v-model="referralCodeType" v-bind:value="d">
                    <span>Promoters</span>
                    <span class="checkmark"></span>
                  </label>
                </div>

                <label>Start Date</label>
                <input type="date" class="form-control" style="margin-bottom: 10px;" v-model="startDate" />
                <label>End Date</label>
                <input type="date" class="form-control" style="margin-bottom: 10px;" v-model="expiryDate" />
                <label>User Points Earned (optional)</label>
                <input type="number" step="0.01" min="0.1" v-model="userPointsEarned" class="form-control"
                  style="margin-bottom: 10px;" placeholder="Enter points value" />
                <label>Activation Status</label>
                <div class="row">
                  <label class="radio radio-success ml-3">
                    <input type="radio" name="activeStatus" v-model="active" v-bind:value="a">
                    <span>Active</span>
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio radio-danger ml-3">
                    <input type="radio" name="activeStatus" v-model="active" v-bind:value="b">
                    <span>Inactive</span>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
                <span class="col-4"></span>

                <button class="btn btn-primary btn-rounded col-2" @click="onSubmit()">
                  Update
                </button>
                <span class="col-4"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import "vue-select/dist/vue-select.css";

export default {
  name: "account-edit",
  mixins: [dateManipulation],

  data() {
    return {
      referralCodeName: "",
      affiliate: '',
      referralCode: "",
      referralCodeType: 1,
      userPointsEarned: "",
      startDate: "",
      expiryDate: "",
      active: 1,
      a: 1,
      b: 0,
      c: 1,
      d: 2
    };
  },

  computed: {

  },

  methods: {
    goBack() {
      return this.affiliate.id ? `/lps/affiliate/referral/${this.affiliate.id}` : {}
    },

    async getBalanceDetails() {
      let token = localStorage.getItem("token");

      if (token == null) {
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      try {
        const res = await axios.get(axios.lpsURL + "/referral_code/" + this.$route.params.id, {
          headers: {
            Authorization: "Bearer " + token
          }
        });

        let details = res.data;
        this.referralCodeName = details.referralDetail.name
        this.affiliate = details.affiliate
        this.referralCode = details.account_number
        this.startDate = details.referralDetail.start_date
        this.expiryDate = details.referralDetail.expiry_date
        this.active = details.referralDetail.active
        this.referralCodeType = details.referralDetail.type
        this.userPointsEarned = details.referralDetail.user_points

      } catch (e) {
        console.error(e);
      }
    },

    getReferralCodeDetails() {
      return {
        name: this.referralCodeName,
        type: this.referralCodeType,
        user_points: this.userPointsEarned,
        start_date: this.startDate,
        expiry_date: this.expiryDate,
        active: this.active,
        _method: "PATCH"
      }
    },
    onSubmit() {
      let token = this.checkToken();

      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }
        axios
          .post(
            axios.lpsURL + '/referral_code/' + + this.$route.params.id, this.getReferralCodeDetails(),
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            if (res.data.success) {
              swal({
                icon: "success",
                text: res.data.message
              }).then(() => {
                this.$router.go(-1);
              });
            } else {
              swal({ icon: "error", text: res.data.message });
            }
          });
      });
    },

    // Check Token
    checkToken() {
      let token = localStorage.getItem("token");
      if (token != null) {
        token = JSON.parse(token);
        token = token.access_token;
        return token;
      }
      return false;
    },

    lps() {
      return this.$lps();
    }
  },

  async created() {
    await this.getBalanceDetails();
  },

  mounted() {

  }
};
</script>
